import { EntityType } from '.';
export interface EntityScorePopoverProps {
  avatarUrl?: string;
  entityType?: EntityType;
  entityName?: string;
  driverName?: string;
  className?: string;
  score: number;
}
